<template>
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
        <vx-card>
            <div slot="no-body" class="full-page-bg-color">
                <div class="vx-row no-gutter justify-center items-center">

                    <!-- IMAGE -->
                    <div class="vx-col hidden lg:block lg:w-1/2">
                        <img
                            src="@/assets/images/pages/create-reset-password.png"
                            alt="login"
                            class="mx-auto"
                        />
                    </div>
                    <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                        <div class="p-4 lg:p-8 login-tabs-container">

                            <!-- TITLE AND DESCRIPTION -->
                            <div class="vx-card__title mb-3">
                                <h4 class="mb-4">{{ $t('create_new_password_title') }}</h4>
                                <p>
                                    {{ $t('create_new_password_description') }}
                                </p>
                            </div>
                            <div>

                                <!-- CURRENT PASSWORD -->
                                <div class="mb-2 flex relative">
                                    <vs-input
                                        v-validate="'required'"
                                        :type="!passEye3 ? 'password' : 'text'"
                                        name="oldPassword"
                                        v-model.trim="userData.oldPassword"
                                        icon-no-border
                                        icon="icon icon-lock"
                                        icon-pack="feather"
                                        class="w-full mt-6"
                                        :label-placeholder="$t('current_password')"
                                        disabled
                                    />
                                    <vs-button
                                        color="primary"
                                        class="absolute right-0 bottom-0"
                                        disabled
                                        type="flat"
                                        @click="passEye3 = !passEye3"
                                        icon-pack="feather"
                                        :icon="passEye3 ? 'icon-eye-off' : 'icon-eye'" />
                                </div>


                                <!-- DESCRIPTION FOR CREATE NEW PASSWORD -->
                                <div class="text-xs mb-5">
                                    <p>
                                        {{ $t('create_new_password_description_2') }}
                                    </p>
                                    <p class="mt-1">
                                        {{ $t('example_password') }}
                                    </p>
                                </div>

                                <!-- NEW PASSWORD -->
                                <div class="mb-2">
                                    <div class="flex items-center relative">
                                        <vs-input
                                            @keyup.enter="submitForm"
                                            v-validate="'required|min:8|max:50|excluded:aDGDuq?)m_L2kftL'"
                                            ref="newPassword"
                                            :type="!passEye1 ? 'password' : 'text'"
                                            name="newPassword"
                                            v-model.trim="userData.password"
                                            icon-no-border
                                            icon="icon icon-lock"
                                            icon-pack="feather"
                                            class="w-full mt-6"
                                            :label-placeholder="$t('new_password')"
                                        />
                                        <vs-button
                                            color="primary"
                                            class="absolute right-0 bottom-0"
                                            type="flat"
                                            @click="passEye1 = !passEye1"
                                            icon-pack="feather"
                                            :icon="passEye1 ? 'icon-eye-off' : 'icon-eye'" />
                                    </div>
                                    <span
                                        class="text-danger text-sm"
                                        v-if="errors.has('newPassword')">
                                        {{ errors.first('newPassword') }}
                                    </span>
                                </div>

                                <!-- CONFIRM PASSWORD -->
                                <div class="mb-4">
                                    <div class="flex items-center relative">
                                        <vs-input
                                            @keyup.enter="submitForm"
                                            v-validate="'required|min:8|max:50|confirmed:newPassword|excluded:aDGDuq?)m_L2kftL'"
                                            :type="!passEye2 ? 'password' : 'text'"
                                            name="repeatNewPassword"
                                            v-model.trim="userData.passwordConfirm"
                                            icon-no-border
                                            icon="icon icon-lock"
                                            icon-pack="feather"
                                            class="w-full mt-6"
                                            :label-placeholder="$t('confirm_new_password')"
                                        />
                                        <vs-button
                                            color="primary"
                                            class="absolute right-0 bottom-0"
                                            type="flat"
                                            @click="passEye2 = !passEye2"
                                            icon-pack="feather"
                                            :icon="passEye2 ? 'icon-eye-off' : 'icon-eye'" />
                                    </div>
                                    <span
                                        class="text-danger text-sm"
                                        v-if="errors.has('repeatNewPassword')">
                                        {{ errors.first('repeatNewPassword') }}
                                    </span>
                                </div>

                                <vs-button class="form-button" @click.prevent="submitForm">{{ $t('replace_password') }}</vs-button>

                                <div class="flex flex-wrap justify-between mt-5">
                                    <router-link :to="{ name: 'log_in' }">{{ $t('return_back') }}</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>

import CheckPassword from "@/pages/Authorization/registration/mixin/CheckPassword";

export default {
    name: "Page",
    mixins:[
        CheckPassword
    ],
    data() {
        return {
            passEye1: false,
            passEye2: false,
            passEye3: false,
            userData: {
                oldPassword: '',
                password: '',
                passwordConfirm : '',
            },
            showPasswords: false,
        }
    },
    beforeCreate() {
        // if (!this.$route.params.password) this.$router.push({ name: 'log_in' })
    },
    created() {
        this.userData.oldPassword = this.$route.params.password;
    },
    methods: {
        submitForm(){
            this.$validator.validateAll().then(async (result) => {
                if (result) {
                    try {
                        this.$vs.loading();

                        await this.$http.post('user/change/password/', this.userData);
                        this.$vs.notify({
                            title:`${ this.$t('succesful') }!`,
                            text: this.$t('please_login_in_new_password'),
                            color:'success'
                        });
                        await this.$router.push({ name: 'log_in' });

                    } catch(error) {
                        if(this.check_error(error.error)){
                            this.$vs.notify({
                                title: this.$t('error'),
                                text: this.$t(error.error),
                                color:'danger'
                            })
                        }
                        if(error.error === "password_cannot_be_the_same"){
                            this.$vs.notify({
                                title: this.$t('error'),
                                text: this.$t(error.error),
                                color:'danger'
                            })
                        }
                        this.$vs.notify({
                            text: error.non_field_errors[0],
                            color: 'danger'
                        })
                    }  finally {
                        this.$vs.loading.close()
                    }
                }
                else {
                    this.$vs.notify({
                        title: this.$t('warning'),
                        text: this.$t('Fillallfields'),
                        color:'danger'
                    })
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
